export default __webpack_public_path__ + "3d2004c799dd14284431279b1e0e7524.glb";